import React from "react";
import { Container } from "reactstrap";
import BookingStats from "./BookingStats";

// Pagina Statistics delle prenotazioni (voce della sidebar sotto Bookings).
const StatsPage = () => (
  <div className="content">
    <Container fluid>
      <BookingStats />
    </Container>
  </div>
);

export default StatsPage;
